<template>
  <v-dialog
    id="nav-profile-dialog"
    v-model="isOpen"
    width="300px"
    theme="light"
  >
    <template #activator="{ props }">
      <v-list-item
        append-icon="fas fa-gear"
        v-bind="props"
        title="Profile"
      />
    </template>

    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        User Info
      </v-card-title>

      <v-card-text v-html="profileDetails" />
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          variants="text"
          @click="isOpen = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ProfileDialog",
  props: {
    profileDetails: String,
    closeProfileList: Function,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  // watch: {
  //   isOpen() {
  //     this.closeProfileList?.();
  //   },
  // },
});
</script>

<style scoped>
#nav-profile-dialog {
  width: 300px;
}
</style>
